
  (function(){
    var layer=document.querySelector('.ph-autumn-leaves');
    if(!layer||!window.matchMedia('(prefers-reduced-motion:no-preference)').matches)return;
    var fallH=0,t;
    function backdrops(){
      var vw=document.documentElement.clientWidth,decorations=[],backgrounds=[];
      document.querySelectorAll('#MainContent>.shopify-section *, .shopify-section-group-footer-group *').forEach(function(el){
        if(el.classList.contains('ph-leaves-backdrop'))return;
        var s=getComputedStyle(el);
        if(s.zIndex==='auto'||parseInt(s.zIndex,10)<3||s.position==='static')return;
        if(el.getBoundingClientRect().width<vw*0.9)return;
        if(s.backgroundColor==='rgba(0, 0, 0, 0)'&&s.backgroundImage==='none')return;
        if(s.transform!=='none'||parseFloat(s.opacity)<1||s.filter!=='none'||s.isolation==='isolate')return;
        backgrounds.push(el);
        Array.prototype.forEach.call(el.children,function(c){
          var cs=getComputedStyle(c);
          if((cs.position==='absolute'||cs.position==='fixed')&&!c.textContent.trim()&&!c.querySelector('img,video,svg,a,button'))decorations.push(c);
        });
      });
      backgrounds.forEach(function(el){el.classList.add('ph-leaves-backdrop');});
      decorations.forEach(function(el){el.classList.add('ph-leaves-deco');});
    }
    function pageH(){
      layer.style.height='0px';
      var h=Math.max(document.body.scrollHeight,document.documentElement.scrollHeight);
      layer.style.height='';
      return h;
    }
    /* The clipping window always matches the page; the fall itself is only re-measured
       if the page changes height by more than 20%, so leaves don't jump. */
    function size(force){
      var h=pageH();
      layer.style.setProperty('--ph-page-h',h+'px');
      if(!force&&fallH&&Math.abs(h-fallH)<fallH*0.2)return;
      fallH=h;
      layer.style.setProperty('--ph-fall-dist',(h+120)+'px');
      layer.style.setProperty('--ph-screens',((h+120)/(window.innerHeight+240)).toFixed(3));
    }
    /* Keep the mobile decoration light: two additional leaves rather than nine. */
    function mobileLeaves(){
      if(window.innerWidth>=750)return;
      var leaves=layer.querySelectorAll('.ph-autumn-leaf'),n=Math.min(leaves.length,2);
      for(var i=0;i<n;i++){
        var c=leaves[i].cloneNode(true),st=leaves[i].style;
        var x=(parseFloat(st.getPropertyValue('--x'))+47)%96+2,ph=(parseFloat(st.getPropertyValue('--phase'))+0.5)%1;
        c.style.setProperty('--x',x.toFixed(1)+'%');c.style.setProperty('--phase',ph.toFixed(3));
        layer.appendChild(c);
      }
    }
    function start(){
      mobileLeaves();backdrops();size(true);
      setTimeout(function(){layer.classList.add('is-ready');},60);
      var lastW=window.innerWidth;
      window.addEventListener('resize',function(){if(window.innerWidth===lastW&&window.innerWidth<750)return;lastW=window.innerWidth;clearTimeout(t);t=setTimeout(function(){size(false);},300);});
      if('ResizeObserver' in window){new ResizeObserver(function(){clearTimeout(t);t=setTimeout(function(){size(false);},300);}).observe(document.body);}
    }
    function queueStart(){
      if('requestIdleCallback' in window)window.requestIdleCallback(start,{timeout:2500});
      else window.setTimeout(start,1200);
    }
    if(document.readyState==='complete')queueStart();else window.addEventListener('load',queueStart,{once:true});
  })();
